import { Anchor, BatteryCharging, Construction, FilePlus2, Fan, Layers, ShieldAlert, Ship, Snowflake, Sofa, Waves, Wrench } from "lucide-react";

export const STEPS = [
  { key: "kunde", label: "Kunde og fartøy", lead: "Hvem er tilbudet til?" },
  { key: "mal", label: "Type arbeid", lead: "Hva slags oppdrag er det?" },
  { key: "omfang", label: "Arbeidsomfang", lead: "Hvilke poster skal med?" },
  { key: "periode", label: "Periode og frister", lead: "Når og hvor gjøres jobben?" },
  { key: "oppsummering", label: "Opprett", lead: "Se over og opprett" },
];

export const ICONS = { anchor: Anchor, ship: Ship, waves: Waves, fan: Fan, layers: Layers, "shield-alert": ShieldAlert, snowflake: Snowflake, construction: Construction, sofa: Sofa, "battery-charging": BatteryCharging, wrench: Wrench, tom: FilePlus2 };

export const PLACES = [
  { key: "flytedokk", label: "Flytedokk" },
  { key: "slipp", label: "Slipp" },
  { key: "kai", label: "Ved kai" },
];

export const BLANK = "tom";
export const DRAFT_KEY = "los.veiviser.draft";

export const EMPTY = {
  customer: { name: "", account_id: null },
  contact: { name: "", email: "" },
  vessel: { name: "", type: "", loa: "", beam: "" },
  template: null,
  off: [],
  extra: [],
  period: { place: null, from: "", days: "" },
  facts: { tender_deadline: "", award_expected: "" },
  name: "",
  note: "",
  practice: false,
};

export const num = (v) => { const n = parseFloat(String(v ?? "").replace(",", ".")); return Number.isFinite(n) ? n : null; };

/** Ready to leave a step? `null` = yes, otherwise the one sentence that says what is missing. */
export function blocker(step, v) {
  if (step === "kunde") {
    if (!v.customer.name.trim()) return "Velg eller skriv inn kunden";
    if (!v.vessel.name.trim()) return "Skriv inn fartøyet";
  }
  if (step === "mal" && !v.template) return "Velg type arbeid – eller «Tomt oppdrag»";
  if (step === "periode" && v.period.from && !(num(v.period.days) > 0)) return "Skriv inn antall døgn";
  return null;
}

export function limitsText(l) {
  if (!l) return "";
  const bits = [l.lengde_m ? `${String(l.lengde_m).replace(".", ",")} m` : null, l.bredde_m ? `${String(l.bredde_m).replace(".", ",")} m bredde` : null].filter(Boolean);
  return bits.length ? `Inntil ${bits.join(" · ")}` : "";
}
